export default "__VITE_ASSET__i98UjAO1__"